import { useState } from 'react'
import { Navbar } from '../../layout/Navbar'
import ScheduleVisitStep from '../../onboarding/steps/ScheduleVisitStep'
import { StepData } from '@/services/onboardingService'
import ScheduleContractSuccess from './ScheduleContractSuccess'

export const ScheduleContractSigningPageContent = () => {
  const [showSuccess, setShowSuccess] = useState(false)

  const handleOnComplete = async (stepData: StepData) => {
    // Lógica para manejar la finalización del paso
    console.log('Paso completado con datos:', stepData)
    setShowSuccess(true)
  }

  return (
    <>
      {/* Mobile Layout */}
      <div className="min-h-screen flex flex-col md:hidden">
        {/* Mobile Header - Solo gradiente */}
        <div
          className="h-48 flex items-center justify-center relative"
          style={{
            background:
              'linear-gradient(180deg, #1789CF 0%, #02298A 84.79%, #021B79 100%)',
            minHeight: '192px',
          }}
        >
          {/* Logo centrado - más grande */}
          <div className="text-center z-10">
            <img
              src="/assets/olr-logo.png"
              alt="OLR Leasing"
              className="filter brightness-0 invert w-40 h-auto mx-auto"
            />
          </div>
        </div>

        {/* Mobile Form section - menos padding top */}
        <div className="flex-1 bg-white flex items-start justify-center pt-8 px-6 pb-6">
          <div className="w-full max-w-md">
            {showSuccess ? (
              <ScheduleContractSuccess
                onFinalize={() => setShowSuccess(false)}
                titulo="Gracias por agendar tu cita"
                descripcion="Hemos agendado tu cita para la firma del contrato de manera exitosa."
              />
            ) : (
              <ScheduleVisitStep
                appointmentType="firma_contrato"
                onComplete={handleOnComplete}
              />
            )}
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden md:flex min-h-screen  flex-col">
        <Navbar />

        {/* Main content with bg-flow */}
        <div
          className="flex-1 flex flex-col items-center justify-center py-1 px-4 border  "
          style={{
            backgroundImage: 'url(/assets/bg-flow.svg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="bg-white px-8 rounded-lg max-w-2xl w-full mx-4 ">
            {showSuccess ? (
              <ScheduleContractSuccess
                onFinalize={() => setShowSuccess(false)}
                titulo="Gracias por agendar tu cita"
                descripcion="Hemos agendado tu cita para la firma del contrato de manera exitosa. Te enviamos los detalles por correo electrónico y te esperamos pronto en nuestras oficinas."
              />
            ) : (
              <ScheduleVisitStep
                appointmentType="firma_contrato"
                onComplete={handleOnComplete}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}
